import React, {Component} from 'react';
import Document from "../../Listview/Document/Document";
import Octicon, {ChevronDown, ChevronUp} from '@githubprimer/octicons-react';

import './DocumentAccordion.css';
import Logo from "../Logo/Logo";

class Accordion extends Component {
    render() {
        let showLogoDisclaimer = false;
        var parent = "#accordion" + this.props.container;
        var parent2 = "accordion" + this.props.panel.id;
        var container = "#collapse" + this.props.panel.id;
        var container2 = "collapse" + this.props.panel.id;
        let accordionContent;
        if (this.props.panel.message) {
            accordionContent = <div dangerouslySetInnerHTML={{__html: this.props.panel.message}}/>
        } else if (this.props.panel.categories) {
            accordionContent = <div id={parent2}>
                {this.props.panel.categories.map(function (item, index) {
                    return <Accordion height={this.props.height} width={this.props.width} panel={item} key={index}
                                      container={this.props.panel.id} setFile={this.props.setFile}
                                      changeRoute={this.props.changeRoute}/>
                }.bind(this))}
            </div>

        } else if (this.props.panel.documents) {
            console.log(this.props.panel.documents);
            accordionContent = <table className="table document-list">
                <tbody>
                {this.props.panel.documents.map(function (group, index) {
                    if (this.props.panel.existingLogos && this.props.panel.existingLogos[group[0].logoId] !== undefined) {
                        showLogoDisclaimer = true;
                        return <React.Fragment>
                            <hr/>
                            <Logo url={this.props.panel.existingLogos[group[0].logoId].path}/>
                            {group.map(function (item, index) {
                                return <Document height={this.props.height} width={this.props.width} document={item}
                                                 key={index}
                                                 setCategory={this.props.setCategory} setFile={this.props.setFile}
                                                 changeRoute={this.props.changeRoute}/>
                            }.bind(this))}
                        </React.Fragment>
                    }
                    return <React.Fragment>
                        {group.map(function (item, index) {
                            return <Document height={this.props.height} width={this.props.width} document={item}
                                             key={index}
                                             setCategory={this.props.setCategory} setFile={this.props.setFile}
                                             changeRoute={this.props.changeRoute}/>
                        }.bind(this))}
                    </React.Fragment>
                }.bind(this))}
                </tbody>
            </table>
        }
        return <div className="card">
            <div className="card-header">
                <a data-toggle="collapse" href={container}
                   className="card-link collapsed no-select">{this.props.panel.title}
                    <Octicon className="accordion-closed" icon={ChevronDown}/>
                    <Octicon className="accordion-opened" icon={ChevronUp}/>
                </a>
            </div>
            <div id={container2} className="collapse" data-parent={parent}>
                <div className="card-body">
                    {accordionContent}
                </div>
            </div>
        </div>
    }
}

export default Accordion;


// WEBPACK FOOTER //
// ./src/Components/Elements/DocumentAccordion/DocumentAccordion.js